export const ExpensesTypeEnum = {
    ADD: 0,
    EDIT: 1,
    DELETE: 2,
    options: [
        {id: 1, text: '总费用'},
        {id: 2, text: '累计费用'},
    ],
};